import { CouponType } from "@/pages/coupon/constant/index";
import { dateFormatter } from "project-config/utils/date-formatter";
import { isOverTimeCoupon } from "../helper/isOverTimeCoupon";
import { ICouponDetailInfo, ICouponListInfo } from "../types";
import {
  getPeriodTimeFilter,
  getRemainingNumberDays,
  getWayFilter,
} from "./coupon-filter";

export const CouponList: ICouponListInfo[] = [
  {
    name: "coupon_animation_applicable",
    data: [],
    sum: 0,
    amount: 0,
    type: CouponType.Animation,
  },
  {
    name: "coupon_qing_applicable",
    data: [],
    sum: 0,
    amount: 0,
    type: CouponType.Qing,
  },
  {
    // 动画不显示抵扣券，只有效果图显示
    name: "coupon_member_applicable",
    data: [],
    sum: 0,
    amount: 0,
    type: CouponType.RenderingMember,
  },
];

export const CouponContentList = (isSubAccount: boolean) =>
  new Map([
    [
      CouponType.Animation,
      [
        {
          title: "coupon_get_way",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: getWayFilter(data.getWay),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_get_time",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.effectiveDate, "yyyy-MM-dd"),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_expired_time_title",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.expireDate, "yyyy-MM-dd"),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_pages_has_used_result",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value:
                isOverTimeCoupon(data.expireDate, !!data.isExpired) &&
                data.couponBalance !== 0
                  ? "coupon_pages_has_expired"
                  : !(data.destName && data.operateTime)
                  ? "coupon_pages_used_up"
                  : isSubAccount
                  ? "coupon_pages_transfer_to_user"
                  : "coupon_pages_transfer_to_subuser",
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return data.isExpired;
          },
          key: "expired",
        },
        {
          title: "coupon_freeze_reason",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: "coupon_freeze_reason_content",
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return Boolean(data.isFreeze);
          },
          key: "freeze",
        },
      ],
    ],
    [
      CouponType.Qing,
      [
        {
          title: "coupon_get_way",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: getWayFilter(data.getWay),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_get_time",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.effectiveDate, "yyyy-MM-dd"),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_expired_time_title",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: dateFormatter(data.expireDate, "yyyy-MM-dd"),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_pages_has_used_result",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value:
                isOverTimeCoupon(data.expireDate, !!data.isExpired) &&
                data.couponBalance !== 0
                  ? "coupon_pages_has_expired"
                  : !(data.destName && data.operateTime)
                  ? "coupon_pages_used_up"
                  : isSubAccount
                  ? "coupon_pages_transfer_to_user"
                  : "coupon_pages_transfer_to_subuser",
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return data.isExpired;
          },
          key: "expired",
        },
      ],
    ],
    [
      CouponType.RenderingMember,
      [
        {
          title: "coupon_get_way",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: getWayFilter(data.getWay),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_valid_time",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value: getPeriodTimeFilter(
                data.effectiveDate,
                data.expireDate,
                data.vaildTerm,
                "yyyy-MM-dd HH:mm:ss"
              ),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return true;
          },
        },
        {
          title: "coupon_time_left",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "coupon_day",
              value: getRemainingNumberDays(data.expireDate),
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return !data.isExpired;
          },
        },
        {
          title: "coupon_pages_has_used_result",
          content: (data: ICouponDetailInfo) => {
            return {
              key: "",
              value:
                data.invalidReason && [35, 36].includes(data?.invalidReason)
                  ? `coupon_pages_transfer_${data?.invalidReason}`
                  : isOverTimeCoupon(data.expireDate, !!data.isExpired) &&
                    data.couponBalance !== 0
                  ? "coupon_pages_has_expired"
                  : "coupon_disk_used",
            };
          },
          visible: (data: ICouponDetailInfo) => {
            return data.isExpired;
          },
          key: "expired",
        },
      ],
    ],
  ]);

export const CouponRulesList = [
  {
    rules: [
      "coupon_rendering_rules_content_1",
      "coupon_rendering_rules_content_2",
      "coupon_rendering_rules_content_3_new",
      "coupon_rendering_rules_content_4",
      "coupon_rendering_rules_content_4_1",
      "coupon_rendering_rules_content_4_2",
      "coupon_rendering_rules_content_4_3",
    ],
    title: "coupon_render_rules_detail_title",
    key: CouponType.Animation,
  },
  {
    rules: ["coupon_qing_rules_content_1"],
    title: "coupon_qingyun_rules_detail_title",
    key: CouponType.Qing,
  },
  {
    rules: [
      "vip_recharge_coupon_rules_list1",
      "vip_recharge_coupon_rules_list2",
      "vip_recharge_coupon_rules_list3",
      "vip_recharge_coupon_rules_list4",
      "vip_recharge_coupon_rules_list5",
      "vip_recharge_coupon_rules_list6",
    ],
    title: "coupon_deduct_rules_detail_title",
    key: CouponType.RenderingMember,
  },
];
